
/**
 * Class to initialize variables with default values
 * @date 1/18/2024 - 3:09:39 PM
 *
 * @export
 * @class ApplicationDefaultValue
 * @typedef {ApplicationDefaultValue}
 */
export class ApplicationDefaultValue {
    static Number = 0;
    static String = '';
    static Boolean = false;
    static Array = [];
    static Undefined = undefined;
    static Null = null;
    static StringEmptyLength = 0;
    static AvsNumberPrefix = "756";
    static DefaultTime = '00:00';
    static DefaultDropdownValue = 'code';
    static DefaultDropdownText = 'translation';

}

